// extracted by mini-css-extract-plugin
export default {"tooltip":"sP-z","arrow":"tP-z"};